import { useParams } from "react-router-dom";
import {gql} from '@apollo/client';
import client from "@/services/apolloClient";
import { useState } from "react";

export const GET_INVOICES_PER_YEAR = gql`
  query ConsultantInvoices($invoiceRequest: ConsultantInvoiceRequestDto!) {
    consultantInvoices(invoiceRequest: $invoiceRequest) {
      invoices {
        year
        uuid
        periodStart
        periodEnd
        month
        invoiceNumber
        invoiceDate
        daysWorked
        dailyRateConsultant
        dailyRateClient
        currency
        clientName
        amountConsultant
        amountClient
        commission
        manualCommission
      }
      year
    }
  }
`;


export const useInvoicesPerYear = () => {
    const { id } = useParams();
    const [allInvoices, setData] = useState(null);
    const [loadingInvoices, setLoading] = useState(false);
    const [errors, setErrors] = useState(null);
    const fetchInvoicesPerYear = async (year) => {
        const { data, loading, error } = await client.query({
            query: GET_INVOICES_PER_YEAR,
            variables: { invoiceRequest: { consultantUuid: id, year: year } },
            fetchPolicy: "network-only",
        });
        setLoading(loading);
        if (data) {
            setData(data);
        }
        if (error) {
            setErrors(error);
        }

        return data.consultantInvoices.invoices;
    };

    return { loadingInvoices, errors, allInvoices, fetchInvoicesPerYear };
};
